<template>
        
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 mb-4 animate__animated animate__fadeIn">

        <div class="content-template extra-rounded flex-y" :style="{ backgroundImage: `url('/storage/${data.thumbnail}')` }" style="height: 400px;">

            <div class="p-3 flex-y extra-rounded" style="justify-content: space-between; height: 100%; background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 1));">

                <div>
                    <h2 class="clip-text-2" style="color: white; text-shadow: 3px 3px #1d1800;">
                        <a v-if="data.type == 'altlan'" style="color: white;" :href="`/altlan`">{{ data.name }}</a>
                        <a v-else style="color: white;" :href="`/event/${ data.slug }`">{{ data.name }}</a>
                        
                    </h2>

                    <div class="flex-x" style="align-content: center; justify-content: flex-start; align-items: flex-start;">
                        <div v-if="data.type == 'altlan'" class="badge bg-warning" style="margin-right: 6px;">
                            <a :href="`/${ data.type }`">altLAN</a>
                        </div>
                        <div v-else class="badge bg-warning" style="margin-right: 6px; color: black;">Event</div>
                    </div>

                    <br>

                    <h5>
                        <span>Starting </span>
                        <span v-text="this.Timestamp(data.start_date)"></span>
                    </h5>

                    <br>

                    <event-registration :event="this.data" :userid="this.userid" :showattendees="false"></event-registration>

                </div>

                <div>
                    <p class="clip-text-4">{{ data.description }}</p>
                </div>

            </div>

        </div>

    </div>

</template>

<script>

import moment from 'moment';

export default {

    data () {
        return {
            registered: false,
            count: 0
        }
    },

    props: ['data', 'userid'],

    created () {
        this.count = this.data.attendees.length;
    },

    methods: {
        Timestamp (date) {
            return moment(date).format('MMMM Do YYYY, hh:mm a');
        },

        UpdateCount(count) {
            this.count = count;
        },

        Update (count, registered) {
            this.count = count;
            this.registered = registered;
        }
    }

}
</script>